var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_setup.FontAwesomeIcon, {
    class: _setup.classes,
    attrs: {
      "icon": _setup.iconToUse,
      "size": _vm.size
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };